import {
  getAllModulesList,
  getModulesCard,
  getModuleInformation,
  getEducationForm,
  getTrialForm,
  updateModuleInformation,
  addNewModuleInformation,
  deleteModule,
  getModulePurpose,
  getModuleResultSkill,
  getModuleDigitalUsage,
  getModuleAbility,
  addModuleAbility,
  deleteModuleAbility,
  updateModuleAbility,
  addModuleCardLogo,
  deleteModuleCardLogo,
  addModuleProgram,
  deleteModuleProgram,
  getAllModuleVolume,
  addModuleVolume,
  getAllModuleThemeVolume,
  getAllModuleAbilityTheme,
  addModuleThemeVolume,
  updateModuleVolume,
  deleteModuleVolume,
  deleteModuleThemeVolume,
  updateModuleThemeVolume,
  getAllModuleLesson,
  getAllModuleLessonTheme,
  addModuleLesson,
  updateModuleLesson,
  deleteModuleLesson,
  getAllLessonType,
  getResourceList,
  getLessonResourceList,
  getAllRoomTypesList,
  getAllModuleRoomList,
  addModuleRoomList,
  updateModuleRoomList,
  deleteModuleRoomList,
  getAllModuleResourceList,
  addModuleResource,
  updateModuleResource,
  deleteModuleResource,
  getAllResourceTypeList,
  getAllModuleReference,
  addModuleReference,
  updateModuleReference,
  deleteModuleReference,
  getAllModuleSite,
  addModuleSite,
  updateModuleSite,
  deleteModuleSite,
  getModuleSchedule,
  getModuleEstimate,
  getAllModuleCriterion,
  addModuleCriterion,
  updateModuleCriterion,
  deleteModuleCriterion,
  getAllModuleCompilers,
  compilers,
  getOrganizationStaff
} from "../api";
import types from "./types";

import notify from "devextreme/ui/notify";

const logError = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "error"
  );

//! GET ALL MODULES LIST
function allModuleListRequest() {
  return {
    type: types.GET_ALL_MODULES_LIST_REQUEST,
    fetchingAllModuleList: true
  };
}

function allModuleListResponse(allModuleList) {
  return {
    type: types.GET_ALL_MODULES_LIST_COMPLETED,
    fetchingAllModuleList: false,
    allModuleList
  };
}

function allModuleListRequestError(allModuleListError) {
  return {
    type: types.GET_ALL_MODULES_LIST_ERROR,
    fetchingAllModuleList: false,
    allModuleListError
  };
}

export function getAllModuleListAction() {
  return dispatch => {
    dispatch(allModuleListRequest());
    return getAllModulesList()
      .then(response => {
        if (response.status === 200) {
          dispatch(allModuleListResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(allModuleListRequestError(err));
      });
  };
}

//! GET MODULE CARD
function moduleCardRequest() {
  return {
    type: types.GET_MODULE_CARD_REQUEST,
    fetchingModuleCard: true
  };
}

function moduleCardResponse(moduleCard) {
  return {
    type: types.GET_MODULE_CARD_COMPLETED,
    fetchingModuleCard: false,
    moduleCard
  };
}

function moduleCardRequestError(fetchingModuleCardError) {
  return {
    type: types.GET_MODULE_CARD_ERROR,
    fetchingModuleCard: false,
    fetchingModuleCardError
  };
}

export function getModuleCardAction(id) {
  return dispatch => {
    dispatch(moduleCardRequest());
    return getModulesCard(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(moduleCardResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(moduleCardRequestError(err));
      });
  };
}

//! GET MODULE INFORMATION
function moduleInfoRequest() {
  return {
    type: types.GET_MODULE_INFORMATION_REQUEST,
    fetchingModuleInformation: true
  };
}

function moduleInfoResponse(moduleInformation) {
  return {
    type: types.GET_MODULE_INFORMATION_COMPLETED,
    fetchingModuleInformation: false,
    moduleInformation
  };
}

function moduleInfoRequestError(fetchingModuleInformationError) {
  return {
    type: types.GET_MODULE_CARD_ERROR,
    fetchingModuleInformation: false,
    fetchingModuleInformationError
  };
}

export function getModuleInformationAction(id) {
  return dispatch => {
    dispatch(moduleInfoRequest());
    return getModuleInformation(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(moduleInfoResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(moduleInfoRequestError(err));
      });
  };
}

//! ADD NEW MODULE INFORMATION
function addNewModuleInfoRequest() {
  return {
    type: types.ADD_NEW_MODULE_INFORMATION_REQUEST,
    fetchingNewModuleInformation: true
  };
}

function addNewModuleResponse(newModuleInformation) {
  return {
    type: types.ADD_NEW_MODULE_INFORMATION_COMPLETED,
    fetchingNewModuleInformation: false,
    newModuleInformation
  };
}

function addNewModuleRequestError(fetchingNewModuleInformationError) {
  return {
    type: types.addNewModuleRequestError,
    newModuleInformation: false,
    fetchingNewModuleInformationError
  };
}

export function addNewModuleInformationAction() {
  return (dispatch) => {
    dispatch(addNewModuleInfoRequest());
    return addNewModuleInformation()
      .then(response => {
        if (response.data.success) {
          dispatch(addNewModuleResponse(response.data));
		  dispatch(getModuleInformationAction(response.data.id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(addNewModuleRequestError(message));
        } else {
          logError(err);
          // dispatch(requestReferenceTypesError(createError("Не удалось загрузить список")));
        }
      });
  };
}

/* export function getReferenceTypes() {
  return dispatch => {
    dispatch(requestReferenceTypes());
    return api
      .getReferenceTypesList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestReferenceTypesCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(requestReferenceTypesError(message));
        } else {
          logError(err);
          dispatch(
            requestReferenceTypesError(
              createError("Не удалось загрузить список")
            )
          );
        }
      });
  };
} */
//! UPDATE MODULE INFORMATION
function updateModuleInfoRequest() {
  return {
    type: types.UPDATE_MODULE_INFORMATION_REQUEST,
    fetchingUpdateModuleInformation: true
  };
}

function updateModuleResponse(updatedModuleInformation) {
  return {
    type: types.UPDATE_MODULE_INFORMATION_COMPLETED,
    fetchingUpdateModuleInformation: false,
    newModuleInformation: {},
    updatedModuleInformation
  };
}

function updateModuleRequestError(fetchingUpdateModuleInformationError) {
  return {
    type: types.UPDATE_MODULE_INFORMATION_ERROR,
    fetchingUpdateModuleInformation: false,
    fetchingUpdateModuleInformationError
  };
}

export function updateModuleInformationAction(id, module) {
  return dispatch => {
    dispatch(updateModuleInfoRequest());
    return updateModuleInformation(id, module)
      .then(response => {
        if (response.data.success) {
          dispatch(updateModuleResponse(response.data));
          dispatch(getModuleInformationAction(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(updateModuleRequestError(err));
        } else {
          logError(err);
          // dispatch(requestReferenceTypesError(createError("Не удалось загрузить список")));
        }
      });
  };
}

//! DELETE MODULE INFORMATION
function deleteModuleRequest() {
  return {
    type: types.DELETE_MODULE_REQUEST,
    fetchingDeletingModule: true
  };
}

function deleteModuleCompleted(deletedModule) {
  return {
    type: types.DELETE_MODULE_COMPLETED,
    fetchingDeletingModule: false,
    deletedModule
  };
}

function deleteModuleError(deleteModuleError) {
  return {
    type: types.DELETE_MODULE_ERROR,
    fetchingDeletingModule: false,
    deleteModuleError
  };
}

export function deleteModuleAction(idList) {
  return async dispatch => {
    dispatch(deleteModuleRequest());

    const response = await Promise.all(idList.map(id => deleteModule(id)));
    if (response.every(({ data }) => data.success === true)) {
      dispatch(deleteModuleCompleted(response));
      dispatch(getAllModuleListAction());
    } else {
      dispatch(deleteModuleError(response));
    }
    return response;
  };
}

//! CHANGE MODULE IFORMATION
export function changeModuleInformationAction(moduleInformation) {
  return {
    type: types.CHANGE_MODULE_IFORMATION,
    moduleInformation
  };
}

//! CHANGE MODULE PURPOSE
export function changeModulePurposeAction(modulePurpose) {
  return {
    type: types.CHANGE_MODULE_PURPOSE,
    modulePurpose
  };
}

//! CHANGE MODULE RESULT SKILL
export function changeModuleResultSkillAction(moduleResultSkill) {
  return {
    type: types.CHANGE_MODULE_RESULT_SKILL,
    moduleResultSkill
  };
}

//! CHANGE MODULE DIGITAL USAGE
export function changeModuleDigitalUsageAction(digitalUsage) {
  return {
    type: types.CHANGE_MODULE_DIGITAL_USAGE,
    digitalUsage
  };
}

//! CHANGE MODULE SCHEDULE
export function changeModuleScheduleAction(moduleSchedule) {
  return {
    type: types.CHANGE_MODULE_SCHEDULE,
    moduleSchedule
  };
}

//! CHANGE MODULE ESTIMATE
export function changeModuleEstimateAction(moduleEstimate) {
  return {
    type: types.CHANGE_MODULE_ESTIMATE,
    moduleEstimate
  };
}

//! GET EDUCATION FORM
function educationFormRequest() {
  return {
    type: types.GET_EDUCATION_FORM_REQUEST,
    fetchingEducationForm: true
  };
}

function educationFormResponse(educationForm) {
  return {
    type: types.GET_EDUCATION_FORM_COMPLETED,
    fetchingEducationForm: false,
    educationForm
  };
}

function educationFormRequestError(fetchingEducationFormError) {
  return {
    type: types.GET_EDUCATION_FORM_ERROR,
    fetchingEducationForm: false,
    fetchingEducationFormError
  };
}

export function getEducationFormAction() {
  return dispatch => {
    dispatch(educationFormRequest());
    return getEducationForm()
      .then(response => {
        if (response.status === 200) {
          dispatch(educationFormResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(educationFormRequestError(err));
      });
  };
}

//! GET TRIAL FORM
function trialFormRequest() {
  return {
    type: types.GET_TRIAL_FORM_REQUEST,
    fetchingTrialForm: true
  };
}

function trialFormResponse(trialForm) {
  return {
    type: types.GET_TRIAL_FORM_COMPLETED,
    fetchingTrialForm: false,
    trialForm
  };
}

function trialFormRequestError(fetchingTrialFormError) {
  return {
    type: types.GET_TRIAL_FORM_ERROR,
    fetchingTrialForm: false,
    fetchingTrialFormError
  };
}

export function getTrialFormAction() {
  return dispatch => {
    dispatch(trialFormRequest());
    return getTrialForm()
      .then(response => {
        if (response.status === 200) {
          dispatch(trialFormResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(trialFormRequestError(err));
      });
  };
}

//! GET MODULE PURPOSE
function modulePurposeRequest() {
  return {
    type: types.GET_MODULE_PURPOSE_REQUEST,
    fetchingModulePurpose: true
  };
}

function modulePurposeResponse(modulePurpose) {
  return {
    type: types.GET_MODULE_PURPOSE_COMPLETED,
    fetchingModulePurpose: false,
    modulePurpose
  };
}

function modulePurposeRequestError(fetchingModulePurposeError) {
  return {
    type: types.GET_MODULE_PURPOSE_ERROR,
    fetchingModulePurpose: false,
    fetchingModulePurposeError
  };
}

export function getModulePurposeAction(id) {
  return dispatch => {
    dispatch(modulePurposeRequest());
    return getModulePurpose(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(modulePurposeResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(modulePurposeRequestError(err));
      });
  };
}

//! GET MODULE RESULT SKILL
function moduleResultSkillRequest() {
  return {
    type: types.GET_MODULE_RESULT_SKILL_REQUEST,
    fetchingModuleResultSkill: true
  };
}

function moduleResultSkillResponse(moduleResultSkill) {
  return {
    type: types.GET_MODULE_RESULT_SKILL_COMPLETED,
    fetchingModuleResultSkill: false,
    moduleResultSkill
  };
}

function moduleResultSkillRequestError(fetchingModuleResultSkillError) {
  return {
    type: types.GET_MODULE_RESULT_SKILL_ERROR,
    fetchingModuleResultSkill: false,
    fetchingModuleResultSkillError
  };
}

export function getModuleResultSkillAction(id) {
  return dispatch => {
    dispatch(moduleResultSkillRequest());
    return getModuleResultSkill(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(moduleResultSkillResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(moduleResultSkillRequestError(err));
      });
  };
}

//! GET MODULE ABILITY
function moduleAbilityRequest() {
  return {
    type: types.GET_MODULE_ABILITY_REQUEST,
    fetchingModuleAbility: true
  };
}

function moduleAbilityResponse(moduleAbility) {
  return {
    type: types.GET_MODULE_ABILITY_COMPLETED,
    fetchingModuleAbility: false,
    moduleAbility
  };
}

function moduleAbilityRequestError(fetchingModuleAbilityError) {
  return {
    type: types.GET_MODULE_ABILITY_ERROR,
    fetchingModuleAbility: false,
    fetchingModuleAbilityError
  };
}

export function getModuleAbilityAction(id) {
  return dispatch => {
    dispatch(moduleAbilityRequest());
    return getModuleAbility(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(moduleAbilityResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(moduleAbilityRequestError(err));
      });
  };
}

//! ADD MODULE ABILITY
function newModuleAbilityRequest() {
  return {
    type: types.ADD_NEW_MODULE_ABILITY_REQUEST,
    fetchingNewModuleAbility: true
  };
}

function newModuleAbilityResponse(newModuleAbility, data) {
  return {
    type: types.ADD_NEW_MODULE_ABILITY_COMPLETED,
    fetchingNewModuleAbility: false,
    newModuleAbility,
    data
  };
}

function newModuleAbilityRequestError(fetchingNewModuleAbilityError) {
  return {
    type: types.ADD_NEW_MODULE_ABILITY_ERROR,
    fetchingNewModuleAbility: false,
    fetchingNewModuleAbilityError
  };
}

export function addNewModuleAbilityAction(id, ability) {
  return dispatch => {
    dispatch(newModuleAbilityRequest());
    return addModuleAbility(id, ability)
      .then(response => {
        if (response.status === 200) {
          dispatch(newModuleAbilityResponse(response.data));
          dispatch(getModuleAbilityAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(newModuleAbilityRequestError(err));
      });
  };
}

//! UPDATE MODULE ABILITY
function updateModuleAbilityRequest() {
  return {
    type: types.UPDATE_MODULE_ABILITY_REQUEST,
    fetchingUpdateModuleAbility: true
  };
}

function updateModuleAbilityResponse(updateModuleAbility) {
  return {
    type: types.UPDATE_MODULE_ABILITY_COMPLETED,
    fetchingUpdateModuleAbility: false,
    updateModuleAbility
  };
}

function updateModuleAbilityRequestError(fetchingUpdateAbilityError) {
  return {
    type: types.UPDATE_MODULE_ABILITY_ERROR,
    fetchingUpdateModuleAbility: false,
    fetchingUpdateAbilityError
  };
}

export function updateModuleAbilityAction(ability, data) {
  return (dispatch, getState) => {
    dispatch(updateModuleAbilityRequest());
    const id = getState().modules.moduleInformation.info.id;
    return updateModuleAbility(id, ability, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateModuleAbilityResponse(response.data));
          dispatch(getModuleAbilityAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(updateModuleAbilityRequestError(err));
      });
  };
}

//! DELETE MODULE ABILITY
function deleteModuleAbilityRequest() {
  return {
    type: types.DELETE_MODULE_ABILITY_REQUEST,
    fetchingDeleteModuleAbility: true
  };
}

function deleteModuleAbilityResponse(deleteModuleAbility) {
  return {
    type: types.DELETE_MODULE_ABILITY_COMPLETED,
    fetchingDeleteModuleAbility: false,
    deleteModuleAbility
  };
}

function deleteModuleAbilityRequestError(fetchingDeleteAbilityError) {
  return {
    type: types.DELETE_MODULE_ABILITY_ERROR,
    fetchingDeleteModuleAbility: false,
    fetchingDeleteAbilityError
  };
}

export function deleteModuleAbilityAction(ability) {
  return (dispatch, getState) => {
    dispatch(deleteModuleAbilityRequest());
    const id = getState().modules.moduleInformation.info.id;
    return deleteModuleAbility(id, ability)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleAbilityResponse(response.data));
          dispatch(getModuleAbilityAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleAbilityRequestError(err));
      });
  };
}

//! GET MODULE DIGITAL USAGE
function moduleDigitalUsageRequest() {
  return {
    type: types.GET_MODULE_DIGITAL_USAGE_REQUEST,
    fetchingModuleDigitalUsage: true
  };
}

function moduleDigitalUsageResponse(digitalUsage) {
  return {
    type: types.GET_MODULE_DIGITAL_USAGE_COMPLETED,
    fetchingModuleDigitalUsage: false,
    digitalUsage
  };
}

function moduleDigitalUsageRequestError(fetchingModuleDigitalUsageError) {
  return {
    type: types.GET_MODULE_DIGITAL_USAGE_ERROR,
    fetchingModuleDigitalUsage: false,
    fetchingModuleDigitalUsageError
  };
}

export function getModuleDigitalUsageAction(id) {
  return dispatch => {
    dispatch(moduleDigitalUsageRequest());
    return getModuleDigitalUsage(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(moduleDigitalUsageResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(moduleDigitalUsageRequestError(err));
      });
  };
}

//! ADD MODULE CARD LOGO
function addModuleCardLogoRequest() {
  return {
    type: types.ADD_MODULE_CARD_LOGO_REQUEST,
    fetchingAddModuleCardLogo: true
  };
}

function addModuleCardLogoResponse(addModuleCardLogo) {
  return {
    type: types.ADD_MODULE_CARD_LOGO_COMPLETED,
    fetchingAddModuleCardLogo: false,
    addModuleCardLogo
  };
}

function addModuleCardLogoRequestError(fetchingAddModuleCardLogoError) {
  return {
    type: types.ADD_MODULE_CARD_LOGO_ERROR,
    fetchingAddModuleCardLogo: false,
    fetchingAddModuleCardLogoError
  };
}

export function addModuleCardLogoAction(image) {
  return (dispatch, getState) => {
    dispatch(addModuleCardLogoRequest());
    const id = getState().modules.moduleInformation.info.id;
    const newModule =
      getState().modules.moduleInformation.info.created === false;

    return Promise.all(image.map(img => addModuleCardLogo(id, img)))
      .then(response => {
        if (response.every(({ data }) => data.success === true)) {
          dispatch(addModuleCardLogoResponse());
          !newModule && dispatch(getModuleCardAction(id));
          !newModule && dispatch(getModuleInformationAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(addModuleCardLogoRequestError(err));
      });
  };
}

//! DELETE MODULE CARD LOGO
function deleteModuleCardLogoRequest() {
  return {
    type: types.DELETE_MODULE_CARD_LOGO_REQUEST,
    fetchingDeleteModuleCardLogo: true
  };
}

function deleteModuleCardLogoResponse(deleteModuleCardLogo) {
  return {
    type: types.DELETE_MODULE_CARD_LOGO_COMPLETED,
    fetchingDeleteModuleCardLogo: false,
    deleteModuleCardLogo
  };
}

function deleteModuleCardLogoRequestError(fetchingDeleteModuleCardLogoError) {
  return {
    type: types.DELETE_MODULE_CARD_LOGO_ERROR,
    fetchingDeleteModuleCardLogo: false,
    fetchingDeleteModuleCardLogoError
  };
}

export function deleteModuleCardLogoAction() {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    const newModule =
      getState().modules.moduleInformation.info.created === false;
    dispatch(deleteModuleCardLogoRequest());
    return deleteModuleCardLogo(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleCardLogoResponse(response.data));
          !newModule && dispatch(getModuleCardAction(id));
          !newModule && dispatch(getModuleInformationAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleCardLogoRequestError(err));
      });
  };
}

//! ADD MODULE PROGRAM
function addModuleProgramRequest() {
  return {
    type: types.ADD_MODULE_PROGRAM_REQUEST,
    fetchingAddModuleProgram: true
  };
}

function addModuleProgramResponse() {
  return {
    type: types.ADD_MODULE_PROGRAM_COMPLETED,
    fetchingAddModuleProgram: false
  };
}

function addModuleProgramRequestError(fetchingAddModuleProgramError) {
  return {
    type: types.ADD_MODULE_PROGRAM_ERROR,
    fetchingAddModuleProgram: false,
    fetchingAddModuleProgramError
  };
}

export function addModuleProgramAction(program) {
  return (dispatch, getState) => {
    dispatch(addModuleProgramRequest());
    const id = getState().modules.moduleInformation.info.id;
    const newModule =
      getState().modules.moduleInformation.info.created === false;

    return Promise.all(program.map(prog => addModuleProgram(id, prog)))
      .then(response => {
        if (response.every(({ data }) => data.success === true)) {
          dispatch(addModuleProgramResponse());
          newModule && dispatch(getModuleInformationAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(addModuleProgramRequestError(err));
      });
  };
}

//! DELETE MODULE PROGRAM
function deleteModuleProgramRequest() {
  return {
    type: types.DELETE_MODULE_PROGRAM_REQUEST,
    fetchingDeleteModuleProgram: true
  };
}

function deleteModuleProgramResponse(deleteModuleProgram) {
  return {
    type: types.DELETE_MODULE_PROGRAM_COMPLETED,
    fetchingDeleteModuleProgram: false,
    deleteModuleProgram
  };
}

function deleteModuleProgramRequestError(fetchingDeleteModuleProgramError) {
  return {
    type: types.DELETE_MODULE_PROGRAM_ERROR,
    fetchingDeleteModuleProgram: false,
    fetchingDeleteModuleProgramError
  };
}

export function deleteModuleProgramAction() {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(deleteModuleProgramRequest());
    return deleteModuleProgram(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleProgramResponse(response.data));
          dispatch(getModuleInformationAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleProgramRequestError(err));
      });
  };
}

//! GET ALL MODULE VOLUME
function getAllModuleVolumeRequest() {
  return {
    type: types.GET_ALL_MODULE_VOLUME_REQUEST,
    fetchingAllModuleVolume: true
  };
}

function getAllModuleVolumeResponse(allModuleVolume) {
  return {
    type: types.GET_ALL_MODULE_VOLUME_COMPLETED,
    fetchingAllModuleVolume: false,
    allModuleVolume
  };
}

function getAllModuleVolumeRequestError(fetchingAllModuleVolumeError) {
  return {
    type: types.GET_ALL_MODULE_VOLUME_ERROR,
    fetchingAllModuleVolume: false,
    fetchingAllModuleVolumeError
  };
}

export function getAllModuleVolumeAction(id) {
  return dispatch => {
    dispatch(getAllModuleVolumeRequest());
    return getAllModuleVolume(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleVolumeResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleVolumeRequestError(err));
      });
  };
}

//! ADD MODULE VOLUME
function addModuleVolumeRequest() {
  return {
    type: types.ADD_MODULE_VOLUME_REQUEST,
    fetchingAddModuleVolume: true
  };
}

function addModuleVolumeResponse(moduleVolume) {
  return {
    type: types.ADD_MODULE_VOLUME_COMPLETED,
    fetchingAddModuleVolume: false,
    moduleVolume
  };
}

function addModuleVolumeRequestError(fetchingAddModuleVolumeError) {
  return {
    type: types.ADD_MODULE_VOLUME_ERROR,
    fetchingAddModuleVolume: false,
    fetchingAddModuleVolumeError
  };
}

export function addModuleVolumeAction(volume) {
  return (dispatch, getState) => {
    dispatch(addModuleVolumeRequest());
    const id = getState().modules.moduleInformation.info.id;

    return addModuleVolume(id, volume)
      .then(response => {
        if (response.status === 200) {
          dispatch(addModuleVolumeResponse(response.data));
          dispatch(getAllModuleVolumeAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(addModuleVolumeRequestError(err));
      });
  };
}

/* fetchingDeleteVolume: false,
deleteModuleVolume: {},
fetchingDeleteoduleVolumeError: null, */

//! UPDATE MODULE VOLUME
function updateModuleVolumeRequest() {
  return {
    type: types.UPDATE_MODULE_VOLUME_REQUEST,
    fetchingUpdateModuleVolume: true
  };
}

function updateModuleVolumeResponse(updateModuleVolume) {
  return {
    type: types.UPDATE_MODULE_VOLUME_COMPLETED,
    fetchingUpdateModuleVolume: false,
    updateModuleVolume
  };
}

function updateModuleVolumeRequestError(fetchingUpdateModuleVolumeError) {
  return {
    type: types.UPDATE_MODULE_VOLUME_ERROR,
    fetchingUpdateModuleVolume: false,
    fetchingUpdateModuleVolumeError
  };
}

export function updateModuleVolumeAction(volumeId, data) {
  return (dispatch, getState) => {
    dispatch(updateModuleVolumeRequest());
    const id = getState().modules.moduleInformation.info.id;

    return updateModuleVolume(id, volumeId, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateModuleVolumeResponse(response.data));
          dispatch(getAllModuleVolumeAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(updateModuleVolumeRequestError(err));
      });
  };
}

//! DELETE MODULE VOLUME
function deleteModuleVolumeRequest() {
  return {
    type: types.DELETE_MODULE_VOLUME_REQUEST,
    fetchingDeleteVolume: true
  };
}

function deleteModuleVolumeResponse(deleteModuleVolume) {
  return {
    type: types.DELETE_MODULE_VOLUME_COMPLETED,
    fetchingDeleteVolume: false,
    deleteModuleVolume
  };
}

function deleteModuleVolumeRequestError(fetchingDeleteoduleVolumeError) {
  return {
    type: types.DELETE_MODULE_VOLUME_ERROR,
    fetchingDeleteVolume: false,
    fetchingDeleteoduleVolumeError
  };
}

export function deleteModuleVolumeAction(volumeId) {
  return (dispatch, getState) => {
    dispatch(deleteModuleVolumeRequest());
    const id = getState().modules.moduleInformation.info.id;

    return deleteModuleVolume(id, volumeId)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleVolumeResponse(response.data));
          dispatch(getAllModuleVolumeAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleVolumeRequestError(err));
      });
  };
}

//! GET ALL MODULE THEME VOLUME
function getAllModuleThemeVolumeRequest() {
  return {
    type: types.GET_ALL_MODULE_THEME_VOLUME_REQUEST,
    fetchingAllModuleThemeVolume: true
  };
}

function getAllModuleThemeVolumeResponse(allModuleThemeVolume) {
  return {
    type: types.GET_ALL_MODULE_THEME_VOLUME_COMPLETED,
    fetchingAllModuleThemeVolume: false,
    allModuleThemeVolume
  };
}

function getAllModuleThemeVolumeRequestError(
  fetchingAllModuleThemeVolumeError
) {
  return {
    type: types.GET_ALL_MODULE_THEME_VOLUME_ERROR,
    fetchingAllModuleThemeVolume: false,
    fetchingAllModuleThemeVolumeError
  };
}

export function getAllModuleThemeVolumeAction(id) {
  return (dispatch, getState) => {
    dispatch(getAllModuleThemeVolumeRequest());
    return getAllModuleThemeVolume(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleThemeVolumeResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleThemeVolumeRequestError(err));
      });
  };
}

//! GET ALL MODULE ABILITY THEME
function getAllModuleAbilityThemeRequest() {
  return {
    type: types.GET_ALL_MODULE_ABILITY_THEME_REQUEST,
    fetchingAllModuleAbilityTheme: true
  };
}

function getAllModuleAbilityThemeResponse(allModuleAbilityTheme) {
  return {
    type: types.GET_ALL_MODULE_ABILITY_THEME_COMPLETED,
    fetchingAllModuleAbilityTheme: false,
    allModuleAbilityTheme
  };
}

function getAllModuleAbilityThemeRequestError(
  fetchingAllModuleAbilityThemeError
) {
  return {
    type: types.GET_ALL_MODULE_ABILITY_THEME_ERROR,
    fetchingAllModuleAbilityTheme: false,
    fetchingAllModuleAbilityThemeError
  };
}

export function getAllModuleAbilityThemeAction(id) {
  return dispatch => {
    dispatch(getAllModuleAbilityThemeRequest());
    return getAllModuleAbilityTheme(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleAbilityThemeResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleAbilityThemeRequestError(err));
      });
  };
}

//! ADD MODULE THEME VOLUME
function addModuleThemeVolumeRequest() {
  return {
    type: types.ADD_MODULE_THEME_VOLUME_REQUEST,
    fetchingAddModuleThemeVolume: true
  };
}

function addModuleThemeVolumeResponse(moduleThemeVolume) {
  return {
    type: types.ADD_MODULE_THEME_VOLUME_COMPLETED,
    fetchingAddModuleThemeVolume: false,
    moduleThemeVolume
  };
}

function addModuleThemeVolumeRequestError(fetchingAddModuleThemeVolumeError) {
  return {
    type: types.ADD_MODULE_THEME_VOLUME_ERROR,
    fetchingAddModuleThemeVolume: false,
    fetchingAddModuleThemeVolumeError
  };
}

export function addModuleThemeVolumeAction(theme) {
  return (dispatch, getState) => {
    dispatch(addModuleThemeVolumeRequest());
    const id = getState().modules.moduleInformation.info.id;
    return addModuleThemeVolume(id, theme)
      .then(response => {
        if (response.status === 200) {
          dispatch(addModuleThemeVolumeResponse(response.data));
          dispatch(getAllModuleThemeVolumeAction(id));
          dispatch(getAllModuleAbilityThemeAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(addModuleThemeVolumeRequestError(err));
      });
  };
}

//! UPDATE MODULE THEME VOLUME
function updateModuleThemeVolumeRequest() {
  return {
    type: types.UPDATE_MODULE_THEME_VOLUME_REQUEST,
    fetchingUpdateModuleThemeVolume: true
  };
}

function updateModuleThemeVolumeResponse(updateModuleThemeVolume) {
  return {
    type: types.UPDATE_MODULE_THEME_VOLUME_COMPLETED,
    fetchingUpdateModuleThemeVolume: false,
    updateModuleThemeVolume
  };
}

function updateModuleThemeVolumeRequestError(
  fetchingUpdateModuleThemeVolumeError
) {
  return {
    type: types.UPDATE_MODULE_THEME_VOLUME_ERROR,
    fetchingUpdateModuleThemeVolume: false,
    fetchingUpdateModuleThemeVolumeError
  };
}

export function updateModuleThemeVolumeAction(themeId, data) {
  return (dispatch, getState) => {
    dispatch(updateModuleThemeVolumeRequest());
    const id = getState().modules.moduleInformation.info.id;

    return updateModuleThemeVolume(id, themeId, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateModuleThemeVolumeResponse(response.data));
          dispatch(getAllModuleThemeVolumeAction(id));
          dispatch(getAllModuleAbilityThemeAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(updateModuleThemeVolumeRequestError(err));
      });
  };
}

//! DELETE MODULE THEME VOLUME
function deleteModuleThemeVolumeRequest() {
  return {
    type: types.DELETE_MODULE_THEME_VOLUME_REQUEST,
    fetchingDeleteModuleThemeVolume: true
  };
}

function deleteModuleThemeVolumeResponse(deletedThemeVolume) {
  return {
    type: types.DELETE_MODULE_THEME_VOLUME_COMPLETED,
    fetchingDeleteModuleThemeVolume: false,
    deletedThemeVolume
  };
}

function deleteModuleThemeVolumeRequestError(
  fetchingDeleteModuleThemeVolumeError
) {
  return {
    type: types.DELETE_MODULE_THEME_VOLUME_ERROR,
    fetchingDeleteModuleThemeVolume: false,
    fetchingDeleteModuleThemeVolumeError
  };
}

export function deleteModuleThemeVolumeAction(themeId) {
  return (dispatch, getState) => {
    dispatch(deleteModuleThemeVolumeRequest());
    const id = getState().modules.moduleInformation.info.id;

    return deleteModuleThemeVolume(id, themeId)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleThemeVolumeResponse(response.data));
          dispatch(getAllModuleThemeVolumeAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleThemeVolumeRequestError(err));
      });
  };
}

//! GET ALL MODULE LESSON (Не вызывал)
function getAllModuleLessonRequest() {
  return {
    type: types.GET_ALL_MODULE_LESSON_REQUEST,
    fetchingAllModuleLesson: true
  };
}

function getAllModuleLessonResponse(allModuleLesson) {
  return {
    type: types.GET_ALL_MODULE_LESSON_COMPLETED,
    fetchingAllModuleLesson: false,
    allModuleLesson
  };
}

function getAllModuleLessonRequestError(fetchingAllModuleLessonError) {
  return {
    type: types.GET_ALL_MODULE_LESSON_ERROR,
    fetchingAllModuleLesson: false,
    fetchingAllModuleLessonError
  };
}

export function getAllModuleLessonAction(id) {
  return dispatch => {
    dispatch(getAllModuleLessonRequest());
    return getAllModuleLesson(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleLessonResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleLessonRequestError(err));
      });
  };
}

//! GET ALL MODULE LESSON THEME
function getAllModuleLessonThemeRequest() {
  return {
    type: types.GET_ALL_MODULE_LESSON_THEME_REQUEST,
    fetchingAllModuleLessonTheme: true
  };
}

function getAllModuleLessonThemeResponse(allModuleLessonTheme) {
  return {
    type: types.GET_ALL_MODULE_LESSON_THEME_COMPLETED,
    fetchingAllModuleLessonTheme: false,
    allModuleLessonTheme
  };
}

function getAllModuleLessonThemeRequestError(
  fetchingAllModuleLessonThemeError
) {
  return {
    type: types.GET_ALL_MODULE_LESSON_THEME_ERROR,
    fetchingAllModuleLessonTheme: false,
    fetchingAllModuleLessonThemeError
  };
}

export function getAllModuleLessonThemeAction(id) {
  return (dispatch, getState) => {
    dispatch(getAllModuleLessonThemeRequest());
    // const id = getState().modules.moduleInformation.info.id;
    return getAllModuleLessonTheme(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleLessonThemeResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleLessonThemeRequestError(err));
      });
  };
}

//! ADD MODULE LESSON
function addModuleLessonRequest() {
  return {
    type: types.ADD_MODULE_LESSON_REQUEST,
    fetchingAddModuleLesson: true
  };
}

function addModuleLessonResponse(moduleLesson) {
  return {
    type: types.ADD_MODULE_LESSON_COMPLETED,
    fetchingAddModuleLesson: false,
    moduleLesson
  };
}

function addModuleLessonRequestError(fetchingAddModuleLessonError) {
  return {
    type: types.ADD_MODULE_LESSON_ERROR,
    fetchingAddModuleLesson: false,
    fetchingAddModuleLessonError
  };
}

export function addModuleLessonAction(data) {
  return (dispatch, getState) => {
    dispatch(addModuleLessonRequest());
    const id = getState().modules.moduleInformation.info.id;
    return addModuleLesson(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(addModuleLessonResponse(response.data));
          dispatch(getAllModuleLessonThemeAction(id));
          // dispatch(getAllModuleAbilityThemeAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(addModuleLessonRequestError(err));
      });
  };
}

//! UPDATE MODULE LESSON
function updateModuleLessonRequest() {
  return {
    type: types.UPDATE_MODULE_LESSON_REQUEST,
    fetchingUpdateModuleLesson: true
  };
}

function updateModuleLessonResponse(updateModuleLesson) {
  return {
    type: types.UPDATE_MODULE_LESSON_COMPLETED,
    fetchingUpdateModuleLesson: false,
    updateModuleLesson
  };
}

function updateModuleLessonRequestError(fetchingUpdateModuleLessonError) {
  return {
    type: types.UPDATE_MODULE_LESSON_ERROR,
    fetchingUpdateModuleLesson: false,
    fetchingUpdateModuleLessonError
  };
}

export function updateModuleLessonAction(idLesson, data) {
  return (dispatch, getState) => {
    dispatch(updateModuleLessonRequest());
    const id = getState().modules.moduleInformation.info.id;
    return updateModuleLesson(id, idLesson, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateModuleLessonResponse(response.data));
          dispatch(getAllModuleLessonThemeAction(id));
          // dispatch(getAllModuleAbilityThemeAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(updateModuleLessonRequestError(err));
      });
  };
}

//! DELETE MODULE LESSON
function deleteModuleLessonRequest() {
  return {
    type: types.DELETE_MODULE_LESSON_REQUEST,
    fetchingDeleteModuleLesson: true
  };
}

function deleteModuleLessonResponse(deleteModuleLesson) {
  return {
    type: types.DELETE_MODULE_LESSON_COMPLETED,
    fetchingDeleteModuleLesson: false,
    deleteModuleLesson
  };
}

function deleteModuleLessonRequestError(fetchingDeleteModuleLessonError) {
  return {
    type: types.DELETE_MODULE_LESSON_ERROR,
    fetchingDeleteModuleLesson: false,
    fetchingDeleteModuleLessonError
  };
}

export function deleteModuleLessonAction(idLesson) {
  return (dispatch, getState) => {
    dispatch(deleteModuleLessonRequest());
    const id = getState().modules.moduleInformation.info.id;
    return deleteModuleLesson(id, idLesson)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleLessonResponse(response.data));
          dispatch(getAllModuleLessonThemeAction(id));
          // dispatch(getAllModuleAbilityThemeAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleLessonRequestError(err));
      });
  };
}

//! GET ALL LESSON TYPE
function getAllLessonTypeRequest() {
  return {
    type: types.GET_ALL_LESSON_TYPE_REQUEST,
    fetchingAllLessonType: true
  };
}

function getAllLessonTypeResponse(allLessonType) {
  return {
    type: types.GET_ALL_LESSON_TYPE_COMPLETED,
    fetchingAllLessonType: false,
    allLessonType
  };
}

function getAllLessonTypeRequestError(fetchingAllLessonTypeError) {
  return {
    type: types.GET_ALL_LESSON_TYPE_ERROR,
    fetchingAllLessonType: false,
    fetchingAllLessonTypeError
  };
}

export function getAllLessonTypeAction() {
  return dispatch => {
    dispatch(getAllLessonTypeRequest());
    return getAllLessonType()
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllLessonTypeResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllLessonTypeRequestError(err));
      });
  };
}

//! GET ALL RESOURCE LIST
function getAllResourceListRequest() {
  return {
    type: types.GET_ALL_RESOURCE_LIST_REQUEST,
    fetchingAllResourceList: true
  };
}

function getAllResourceListResponse(allResourceList) {
  return {
    type: types.GET_ALL_RESOURCE_LIST_COMPLETED,
    fetchingAllResourceList: false,
    allResourceList
  };
}

function getAllResourceListRequestError(fetchingAllResourceListError) {
  return {
    type: types.GET_ALL_RESOURCE_LIST_ERROR,
    fetchingAllResourceList: false,
    fetchingAllResourceListError
  };
}

export function getAllResourceListAction() {
  return dispatch => {
    dispatch(getAllResourceListRequest());
    return getResourceList()
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllResourceListResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllResourceListRequestError(err));
      });
  };
}

//! GET LESSON RESOURCE LIST
function getLessonResourceListRequest() {
  return {
    type: types.GET_LESSON_RESOURCE_LIST_REQUEST,
    fetchingLessonResourceList: true
  };
}

function getLessonResourceListResponse(lessonResourceList) {
  return {
    type: types.GET_LESSON_RESOURCE_LIST_COMPLETED,
    fetchingLessonResourceList: false,
    lessonResourceList
  };
}

function getLessonResourceListRequestError(fetchingLessonResourceListError) {
  return {
    type: types.GET_LESSON_RESOURCE_LIST_ERROR,
    fetchingLessonResourceList: false,
    fetchingLessonResourceListError
  };
}

export function getLessonResourceListAction() {
  return (dispatch, getState) => {
    dispatch(getLessonResourceListRequest());
    const id = getState().modules.moduleInformation.info.id;
    return getLessonResourceList(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getLessonResourceListResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getLessonResourceListRequestError(err));
      });
  };
}

//! GET ALL ROOM TYPES LIST
function getAllRoomTypesListRequest() {
  return {
    type: types.GET_ALL_ROOM_TYPES_LIST_REQUEST,
    fetchingAllRoomTypesList: true
  };
}

function getAllRoomTypesListResponse(allRoomTypesList) {
  return {
    type: types.GET_ALL_ROOM_TYPES_LIST_COMPLETED,
    fetchingAllRoomTypesList: false,
    allRoomTypesList
  };
}

function getAllRoomTypesListRequestError(fetchingAllRoomTypesListError) {
  return {
    type: types.GET_ALL_ROOM_TYPES_LIST_ERROR,
    fetchingAllRoomTypesList: false,
    fetchingAllRoomTypesListError
  };
}

export function getAllRoomTypesListAction() {
  return dispatch => {
    dispatch(getAllRoomTypesListRequest());
    return getAllRoomTypesList()
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllRoomTypesListResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllRoomTypesListRequestError(err));
      });
  };
}

//! GET ALL MODULE ROOM LIST
function getAllModuleRoomListRequest() {
  return {
    type: types.GET_ALL_MODULE_ROOM_LIST_REQUEST,
    fetchingAllModuleRoomList: true
  };
}

function getAllModuleRoomListResponse(allModuleRoomList) {
  return {
    type: types.GET_ALL_MODULE_ROOM_LIST_COMPLETED,
    fetchingAllModuleRoomList: false,
    allModuleRoomList
  };
}

function getAllModuleRoomListRequestError(fetchingAllModuleRoomListError) {
  return {
    type: types.GET_ALL_MODULE_ROOM_LIST_ERROR,
    fetchingAllModuleRoomList: false,
    fetchingAllModuleRoomListError
  };
}

export function getAllModuleRoomListAction(id) {
  return dispatch => {
    dispatch(getAllModuleRoomListRequest());
    return getAllModuleRoomList(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleRoomListResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleRoomListRequestError(err));
      });
  };
}

//! ADD MODULE ROOM LIST
function addModuleRoomListRequest() {
  return {
    type: types.ADD_MODULE_ROOM_LIST_REQUEST,
    fetchingModuleRoomList: true
  };
}

function addModuleRoomListResponse(moduleRoomList) {
  return {
    type: types.ADD_MODULE_ROOM_LIST_COMPLETED,
    fetchingModuleRoomList: false,
    moduleRoomList
  };
}

function addModuleRoomListRequestError(fetchingModuleRoomListError) {
  return {
    type: types.ADD_MODULE_ROOM_LIST_ERROR,
    fetchingModuleRoomList: false,
    fetchingModuleRoomListError
  };
}

export function addModuleRoomListAction(data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(addModuleRoomListRequest());
    return addModuleRoomList(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(addModuleRoomListResponse(response.data));
          dispatch(getAllModuleRoomListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(addModuleRoomListRequestError(err));
      });
  };
}

//! UPDATE MODULE ROOM
function updateModuleRoomRequest() {
  return {
    type: types.UPDATE_MODULE_ROOM_REQUEST,
    fetchingUpdateModuleRoom: true
  };
}

function updateModuleRoomResponse(updatedModuleRoom) {
  return {
    type: types.UPDATE_MODULE_ROOM_COMPLETED,
    fetchingUpdateModuleRoom: false,
    updatedModuleRoom
  };
}

function updateModuleRoomRequestError(fetchingUpdateModuleRoomError) {
  return {
    type: types.UPDATE_MODULE_ROOM_ERROR,
    fetchingUpdateModuleRoom: false,
    fetchingUpdateModuleRoomError
  };
}

export function updateModuleRoomAction(idRoom, data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(updateModuleRoomRequest());
    return updateModuleRoomList(id, idRoom, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateModuleRoomResponse(response.data));
          dispatch(getAllModuleRoomListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(updateModuleRoomRequestError(err));
      });
  };
}

//! DELETE MODULE ROOM
function deleteModuleRoomRequest() {
  return {
    type: types.DELETE_MODULE_ROOM_REQUEST,
    fetchingDeleteModuleRoom: true
  };
}

function deleteModuleRoomResponse(deletedModuleRoom) {
  return {
    type: types.DELETE_MODULE_ROOM_COMPLETED,
    fetchingDeleteModuleRoom: false,
    deletedModuleRoom
  };
}

function deleteModuleRoomRequestError(fetchingDeleteModuleRoomError) {
  return {
    type: types.DELETE_MODULE_ROOM_ERROR,
    fetchingDeleteModuleRoom: false,
    fetchingDeleteModuleRoomError
  };
}

export function deleteModuleRoomAction(idRoom) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(deleteModuleRoomRequest());
    return deleteModuleRoomList(id, idRoom)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleRoomResponse(response.data));
          dispatch(getAllModuleRoomListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleRoomRequestError(err));
      });
  };
}

//! GET ALL MODULE RESOURCE LIST
function getAllModuleResourceListRequest() {
  return {
    type: types.GET_ALL_MODULE_RESOURCE_LIST_REQUEST
  };
}

function getAllModuleResourceListResponse(allModuleResourceList) {
  return {
    type: types.GET_ALL_MODULE_RESOURCE_LIST_COMPLETED,
    allModuleResourceList
  };
}

function getAllModuleResourceListRequestError(
  fetchingAllModuleResourceListError
) {
  return {
    type: types.GET_ALL_MODULE_RESOURCE_LIST_ERROR,
    fetchingAllModuleResourceListError
  };
}

export function getAllModuleResourceListAction(id) {
  return dispatch => {
    dispatch(getAllModuleResourceListRequest());
    return getAllModuleResourceList(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleResourceListResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleResourceListRequestError(err));
      });
  };
}

//! ADD MODULE RESOURCE
function addModuleResourceRequest() {
  return {
    type: types.ADD_MODULE_RESOURCE_REQUEST
  };
}

function addModuleResourceResponse(moduleResource) {
  return {
    type: types.ADD_MODULE_RESOURCE_COMPLETED,
    moduleResource
  };
}

function addModuleResourceRequestError(fetchingAddModuleResourceError) {
  return {
    type: types.ADD_MODULE_RESOURCE_ERROR,
    fetchingAddModuleResourceError
  };
}

export function addModuleResourceAction(data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(addModuleResourceRequest());
    return addModuleResource(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(addModuleResourceResponse(response.data));
          dispatch(getAllModuleResourceListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(addModuleResourceRequestError(err));
      });
  };
}

//! UPDATE MODULE RESOURCE
function updateModuleResourceRequest() {
  return {
    type: types.UPDATE_MODULE_ROOM_REQUEST
  };
}

function updateModuleResourceResponse(updatedModuleResource) {
  return {
    type: types.UPDATE_MODULE_ROOM_COMPLETED,
    updatedModuleResource
  };
}

function updateModuleResourceRequestError(fetchingUpdateModuleResourceError) {
  return {
    type: types.UPDATE_MODULE_ROOM_ERROR,
    fetchingUpdateModuleResourceError
  };
}

export function updateModuleResourceAction(idResource, data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(updateModuleResourceRequest());
    return updateModuleResource(id, idResource, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateModuleResourceResponse(response.data));
          dispatch(getAllModuleResourceListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(updateModuleResourceRequestError(err));
      });
  };
}

//! DELETE MODULE RESOURCE
function deleteModuleResourceRequest() {
  return {
    type: types.DELETE_MODULE_RESOURCE_REQUEST
  };
}

function deleteModuleResourceResponse(deletedModuleResource) {
  return {
    type: types.DELETE_MODULE_RESOURCE_COMPLETED,
    deletedModuleResource
  };
}

function deleteModuleResourceRequestError(fetchingDeleteModuleResourceError) {
  return {
    type: types.DELETE_MODULE_RESOURCE_ERROR,
    fetchingDeleteModuleResourceError
  };
}

export function deleteModuleResourceAction(idResource) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(deleteModuleResourceRequest());
    return deleteModuleResource(id, idResource)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleResourceResponse(response.data));
          dispatch(getAllModuleResourceListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleResourceRequestError(err));
      });
  };
}

//! GET ALL RESOURCE TYPE LIST
function getAllResourceTypeListRequest() {
  return {
    type: types.GET_ALL_RESOURCE_TYPE_LIST_REQUEST
  };
}

function getAllResourceTypeListResponse(allResourceTypeList) {
  return {
    type: types.GET_ALL_RESOURCE_TYPE_LIST_COMPLETED,
    allResourceTypeList
  };
}

function getAllResourceTypeListRequestError(fetchingAllRoomTypesListError) {
  return {
    type: types.GET_ALL_RESOURCE_TYPE_LIST_ERROR,
    fetchingAllRoomTypesListError
  };
}

export function getAllResourceTypeListAction() {
  return dispatch => {
    dispatch(getAllResourceTypeListRequest());
    return getAllResourceTypeList()
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllResourceTypeListResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllResourceTypeListRequestError(err));
      });
  };
}

//! GET ALL MODULE REFERENCE LIST
function getAllModuleReferenceListRequest() {
  return {
    type: types.GET_ALL_MODULE_REFERENCE_LIST_REQUEST
  };
}

function getAllModuleReferenceListResponse(allModuleReferenceList) {
  return {
    type: types.GET_ALL_MODULE_REFERENCE_LIST_COMPLETED,
    allModuleReferenceList
  };
}

function getAllModuleReferenceListRequestError(
  fetchingAllModuleReferenceListError
) {
  return {
    type: types.GET_ALL_MODULE_REFERENCE_LIST_ERROR,
    fetchingAllModuleReferenceListError
  };
}

export function getAllModuleReferenceListAction(id) {
  return dispatch => {
    dispatch(getAllModuleReferenceListRequest());
    return getAllModuleReference(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleReferenceListResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleReferenceListRequestError(err));
      });
  };
}

//! ADD MODULE REFERENCE
function addModuleReferenceRequest() {
  return {
    type: types.ADD_MODULE_REFERENCE_REQUEST
  };
}

function addModuleReferenceResponse(moduleReference) {
  return {
    type: types.ADD_MODULE_REFERENCE_COMPLETED,
    moduleReference
  };
}

function addModuleReferenceRequestError(fetchingAddModuleReferenceError) {
  return {
    type: types.ADD_MODULE_REFERENCE_ERROR,
    fetchingAddModuleReferenceError
  };
}

export function addModuleReferenceAction(data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(addModuleReferenceRequest());
    return addModuleReference(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(addModuleReferenceResponse(response.data));
          dispatch(getAllModuleReferenceListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(addModuleReferenceRequestError(err));
      });
  };
}

//! UPDATE MODULE REFERENCE
function updateModuleReferenceRequest() {
  return {
    type: types.UPDATE_MODULE_REFERENCE_REQUEST
  };
}

function updateModuleReferenceResponse(updatedModuleReference) {
  return {
    type: types.UPDATE_MODULE_REFERENCE_COMPLETED,
    updatedModuleReference
  };
}

function updateModuleReferenceRequestError(fetchingUpdateModuleReferenceError) {
  return {
    type: types.UPDATE_MODULE_REFERENCE_ERROR,
    fetchingUpdateModuleReferenceError
  };
}

export function updateModuleReferenceAction(idReference, data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(updateModuleReferenceRequest());
    return updateModuleReference(id, idReference, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateModuleReferenceResponse(response.data));
          dispatch(getAllModuleReferenceListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(updateModuleReferenceRequestError(err));
      });
  };
}

//! DELETE MODULE REFERENCE
function deleteModuleReferenceRequest() {
  return {
    type: types.DELETE_MODULE_REFERENCE_REQUEST
  };
}

function deleteModuleReferenceResponse(deletedModuleReference) {
  return {
    type: types.DELETE_MODULE_REFERENCE_COMPLETED,
    deletedModuleReference
  };
}

function deleteModuleReferenceRequestError(fetchingDeleteModuleReferenceError) {
  return {
    type: types.DELETE_MODULE_REFERENCE_ERROR,
    fetchingDeleteModuleReferenceError
  };
}

export function deleteModuleReferenceAction(idReference) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(deleteModuleReferenceRequest());
    return deleteModuleReference(id, idReference)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleReferenceResponse(response.data));
          dispatch(getAllModuleReferenceListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleReferenceRequestError(err));
      });
  };
}

//! GET ALL MODULE SITE LIST
function getAllModuleSiteListRequest() {
  return {
    type: types.GET_ALL_MODULE_SITE_LIST_REQUEST
  };
}

function getAllModuleSiteListResponse(allModuleSiteList) {
  return {
    type: types.GET_ALL_MODULE_SITE_LIST_COMPLETED,
    allModuleSiteList
  };
}

function getAllModuleSiteListRequestError(fetchingAllModuleSiteListError) {
  return {
    type: types.GET_ALL_MODULE_SITE_LIST_ERROR,
    fetchingAllModuleSiteListError
  };
}

export function getAllModuleSiteListAction(id) {
  return dispatch => {
    dispatch(getAllModuleSiteListRequest());
    return getAllModuleSite(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleSiteListResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleSiteListRequestError(err));
      });
  };
}

//! ADD MODULE SITE
function addModuleSiteRequest() {
  return {
    type: types.ADD_MODULE_SITE_REQUEST
  };
}

function addModuleSiteResponse(moduleSite) {
  return {
    type: types.ADD_MODULE_SITE_COMPLETED,
    moduleSite
  };
}

function addModuleSiteRequestError(fetchingAddModuleSiteError) {
  return {
    type: types.ADD_MODULE_SITE_ERROR,
    fetchingAddModuleSiteError
  };
}

export function addModuleSiteAction(data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(addModuleSiteRequest());
    return addModuleSite(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(addModuleSiteResponse(response.data));
          dispatch(getAllModuleSiteListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(addModuleSiteRequestError(err));
      });
  };
}

//! UPDATE MODULE SITE
function updateModuleSiteRequest() {
  return {
    type: types.UPDATE_MODULE_SITE_REQUEST
  };
}

function updateModuleSiteResponse(updatedModuleSite) {
  return {
    type: types.UPDATE_MODULE_SITE_COMPLETED,
    updatedModuleSite
  };
}

function updateModuleSiteRequestError(fetchingUpdateModuleSiteError) {
  return {
    type: types.UPDATE_MODULE_SITE_ERROR,
    fetchingUpdateModuleSiteError
  };
}

export function updateModuleSiteAction(idSite, data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(updateModuleSiteRequest());
    return updateModuleSite(id, idSite, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateModuleSiteResponse(response.data));
          dispatch(getAllModuleSiteListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(updateModuleSiteRequestError(err));
      });
  };
}

//! DELETE MODULE SITE
function deleteModuleSiteRequest() {
  return {
    type: types.DELETE_MODULE_SITE_REQUEST
  };
}

function deleteModuleSiteResponse(deletedModuleSite) {
  return {
    type: types.DELETE_MODULE_SITE_COMPLETED,
    deletedModuleSite
  };
}

function deleteModuleSiteRequestError(fetchingDeleteModuleSiteError) {
  return {
    type: types.DELETE_MODULE_SITE_ERROR,
    fetchingDeleteModuleSiteError
  };
}

export function deleteModuleSiteAction(idSite) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(deleteModuleSiteRequest());
    return deleteModuleSite(id, idSite)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleSiteResponse(response.data));
          dispatch(getAllModuleSiteListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleSiteRequestError(err));
      });
  };
}

//! GET MODULE SCHEDULE
function getModuleScheduleRequest() {
  return {
    type: types.GET_MODULE_SCHEDULE_REQUEST
  };
}

function getModuleScheduleResponse(moduleSchedule) {
  return {
    type: types.GET_MODULE_SCHEDULE_COMPLETED,
    moduleSchedule
  };
}

function getModuleScheduleRequestError(fetchingModuleScheduleError) {
  return {
    type: types.GET_MODULE_SCHEDULE_ERROR,
    fetchingModuleScheduleError
  };
}

export function getModuleScheduleAction(idModule) {
  return dispatch => {
    dispatch(getModuleScheduleRequest());
    return getModuleSchedule(idModule)
      .then(response => {
        if (response.status === 200) {
          dispatch(getModuleScheduleResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getModuleScheduleRequestError(err));
      });
  };
}

export function saveAllModuleScheduleAction() {
  return (dispatch, getState) => {
    const idModule = getState().modules.moduleInformation.info.id;
    const allModuleVolume = getState().modules.allModuleVolume;
    const updateVolume = allModuleVolume.map(item => {
      return {
        id: item.id,
        main: {
          number: item.number,
          name: item.name
        },
        schedule: {
          week: item.week
        }
      };
    });

    return Promise.all(
      updateVolume.map(volume =>
        updateModuleVolume(idModule, volume.id, volume)
      )
    )
      .then(response => {
        if (response.every(({ data }) => data.success === true)) {
          // refresh add
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
}

//! GET MODULE ESTIMATE
function getModuleEstimateRequest() {
  return {
    type: types.GET_MODULE_ESTIMATE_REQUEST
  };
}

function getModuleEstimateResponse(moduleEstimate) {
  return {
    type: types.GET_MODULE_ESTIMATE_COMPLETED,
    moduleEstimate
  };
}

function getModuleEstimateRequestError(fetchingModuleEstimateError) {
  return {
    type: types.GET_MODULE_ESTIMATE_ERROR,
    fetchingModuleEstimateError
  };
}

export function getModuleEstimateAction(idModule) {
  return dispatch => {
    dispatch(getModuleEstimateRequest());
    return getModuleEstimate(idModule)
      .then(response => {
        if (response.status === 200) {
          dispatch(getModuleEstimateResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getModuleEstimateRequestError(err));
      });
  };
}

//! GET ALL MODULE CRITERION LIST
function getAllModuleCriterionListRequest() {
  return {
    type: types.GET_ALL_MODULE_CRITERION_LIST_REQUEST
  };
}

function getAllModuleCriterionListResponse(allModuleCriterionList) {
  return {
    type: types.GET_ALL_MODULE_CRITERION_LIST_COMPLETED,
    allModuleCriterionList
  };
}

function getAllModuleCriterionListRequestError(
  fetchingAllModuleCriterionListError
) {
  return {
    type: types.GET_ALL_MODULE_CRITERION_LIST_ERROR,
    fetchingAllModuleCriterionListError
  };
}

export function getAllModuleCriterionListAction(id) {
  return dispatch => {
    dispatch(getAllModuleCriterionListRequest());
    return getAllModuleCriterion(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleCriterionListResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleCriterionListRequestError(err));
      });
  };
}

//! ADD MODULE CRITERION
function addModuleCriterionRequest() {
  return {
    type: types.ADD_MODULE_CRITERION_REQUEST
  };
}

function addModuleCriterionResponse(moduleCriterion) {
  return {
    type: types.ADD_MODULE_CRITERION_COMPLETED,
    moduleCriterion
  };
}

function addModuleCriterionRequestError(fetchingAddModuleCriterionError) {
  return {
    type: types.ADD_MODULE_CRITERION_ERROR,
    fetchingAddModuleCriterionError
  };
}

export function addModuleCriterionAction(data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(addModuleCriterionRequest());
    return addModuleCriterion(id, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(addModuleCriterionResponse(response.data));
          dispatch(getAllModuleCriterionListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(addModuleCriterionRequestError(err));
      });
  };
}

//! UPDATE MODULE CRITERION
function updateModuleCriterionRequest() {
  return {
    type: types.UPDATE_MODULE_CRITERION_REQUEST
  };
}

function updateModuleCriterionResponse(updatedModuleCriterion) {
  return {
    type: types.UPDATE_MODULE_CRITERION_COMPLETED,
    updatedModuleCriterion
  };
}

function updateModuleCriterionRequestError(fetchingUpdateModuleCriterionError) {
  return {
    type: types.UPDATE_MODULE_CRITERION_ERROR,
    fetchingUpdateModuleCriterionError
  };
}

export function updateModuleCriterionAction(idCriterion, data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(updateModuleCriterionRequest());
    return updateModuleCriterion(id, idCriterion, data)
      .then(response => {
        if (response.status === 200) {
          dispatch(updateModuleCriterionResponse(response.data));
          dispatch(getAllModuleCriterionListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(updateModuleCriterionRequestError(err));
      });
  };
}

//! DELETE MODULE CRITERION
function deleteModuleCriterionRequest() {
  return {
    type: types.DELETE_MODULE_CRITERION_REQUEST
  };
}

function deleteModuleCriterionResponse(deletedModuleCriterion) {
  return {
    type: types.DELETE_MODULE_CRITERION_COMPLETED,
    deletedModuleCriterion
  };
}

function deleteModuleCriterionRequestError(fetchingDeleteModuleCriterionError) {
  return {
    type: types.DELETE_MODULE_CRITERION_ERROR,
    fetchingDeleteModuleCriterionError
  };
}

export function deleteModuleCriterionAction(idCriterion) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(deleteModuleCriterionRequest());
    return deleteModuleCriterion(id, idCriterion)
      .then(response => {
        if (response.status === 200) {
          dispatch(deleteModuleCriterionResponse(response.data));
          dispatch(getAllModuleCriterionListAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(deleteModuleCriterionRequestError(err));
      });
  };
}

//! GET ALL MODULE COMPILERS
function getAllModuleCompilersRequest() {
  return {
    type: types.GET_ALL_MODULE_COMPILERS_REQUEST
  };
}

function getAllModuleCompilersResponse(allModuleCompilers) {
  return {
    type: types.GET_ALL_MODULE_COMPILERS_COMPLETED,
    allModuleCompilers
  };
}

function getAllModuleCompilersRequestError(fetchingAllModuleCompilersError) {
  return {
    type: types.GET_ALL_MODULE_COMPILERS_ERROR,
    fetchingAllModuleCompilersError
  };
}

export function getAllModuleCompilersAction(id) {
  return dispatch => {
    dispatch(getAllModuleCompilersRequest());
    return getAllModuleCompilers(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getAllModuleCompilersResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getAllModuleCompilersRequestError(err));
      });
  };
}

//! MODULE COMPILERS
function moduleCompilersRequest() {
  return {
    type: types.MODULE_COMPILERS_REQUEST
  };
}

function moduleCompilersResponse(moduleCompilers) {
  return {
    type: types.MODULE_COMPILERS_COMPLETED,
    moduleCompilers
  };
}

function moduleCompilersRequestError(fetchingModuleCompilersError) {
  return {
    type: types.MODULE_COMPILERS_ERROR,
    fetchingModuleCompilersError
  };
}

export function moduleCompilersAction(data) {
  return (dispatch, getState) => {
    const id = getState().modules.moduleInformation.info.id;
    dispatch(moduleCompilersRequest());
    return compilers(data)
      .then(response => {
        if (response.status === 200) {
          dispatch(moduleCompilersResponse(response.data));
          dispatch(getAllModuleCompilersAction(id));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(moduleCompilersRequestError(err));
      });
  };
}

//! GET ORGANIZATION
function getOrganizationStaffRequest() {
  return {
    type: types.GET_ORGANIZATION_STAFF_REQUEST
  };
}

function getOrganizationStaffResponse(organizationStaff) {
  return {
    type: types.GET_ORGANIZATION_STAFF_COMPLETED,
    organizationStaff
  };
}

function getOrganizationStaffRequestError(fetchingOrganizationStaffError) {
  return {
    type: types.GET_ORGANIZATION_STAFF_ERROR,
    fetchingOrganizationStaffError
  };
}

export function getOrganizationStaffAction(id) {
  return dispatch => {
    dispatch(getOrganizationStaffRequest());
    return getOrganizationStaff(id)
      .then(response => {
        if (response.status === 200) {
          dispatch(getOrganizationStaffResponse(response.data));
        } else {
          throw new Error(response.data);
        }
      })
      .catch(err => {
        dispatch(getOrganizationStaffRequestError(err));
      });
  };
}
